import script from "./InternalNotesToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalNotesToggle.vue?vue&type=script&setup=true&lang=js"

import "./InternalNotesToggle.vue?vue&type=style&index=0&id=6fb5363f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb5363f"]])

export default __exports__